import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { EmployeeService } from 'src/app/providers/employee/employee.service';
import { EnergyResourceService } from 'src/app/providers/energy-resource/energy-resource.service';
import { NotificationService } from 'src/app/service/toaster/notification.service';
declare let $ : any;
@Component({
  selector: 'app-passport-modal',
  templateUrl: './passport-modal.component.html',
  styleUrls: ['./passport-modal.component.scss']
})
export class PassportModalComponent implements OnInit {
  @Input() header;
  @Input() empId;
  @Input() passportId;
  pasForm : FormGroup;
  loading = false;
  submitted = false;
  certFile: any;
  result: any = [];
  constructor(
    private erService : EnergyResourceService,
    private notifyService : NotificationService,
    private empService : EmployeeService,
  ) { }

  ngOnInit(): void {
    this.pasForm = new FormGroup({
      psprt_id : new FormControl(''),
      user_id : new FormControl(''),
      country_id : new FormControl('' , Validators.required),
      passport_no : new FormControl('' , Validators.required),
      valid_from : new FormControl('' , Validators.required),
      valid_to : new FormControl('' , Validators.required),
      attachment : new FormControl('' ),
    })
    this.pasForm.patchValue({
      user_id : this.empId,
      psprt_id : this.passportId
    })
    if(this.passportId != '') {
      this.editEmpPassport(this.passportId);
    }
  }
  public findInvalidControls(): any[] {
    const invalid = [];
    const controls = this.pasForm.controls;
    for (const name in controls) {
        if (controls[name].invalid) {
            invalid.push(name);
        }
    }
    return invalid;
  }
  get passportErrorMsg() { return this.pasForm.controls }
  onSubmitPassport(): void {
    this.submitted = true;
    if(this.pasForm.invalid) {
      console.log(this.findInvalidControls());
      return
    }
    if(this.empId == '')  {
      console.log(this.empId , 'id')
      return
    }
    const passportFormData = new FormData();
    passportFormData.append('country_id', this.pasForm.get('country_id').value);
    passportFormData.append('passport_no', this.pasForm.get('passport_no').value);
    passportFormData.append('valid_from', this.pasForm.get('valid_from').value);
    passportFormData.append('valid_to', this.pasForm.get('valid_to').value);
    passportFormData.append('user_id', this.empId);
    passportFormData.append('attachment', this.certFile);
    passportFormData.append('psprt_id', this.passportId);
    this.empService.addEmployeePassport(passportFormData , this.passportId).subscribe( res => {
      this.submitted = false;
      this.result = res;
      if(this.result.status){
        this.notifyService.showSuccess(this.result.msg);
        this.pasForm.reset();
        $('#passport_modal').modal('hide');
      } else {
        this.notifyService.showError(this.result.msg);
      }
    });
  }

  onFileChange(event) : void {
    if(event.target.files.length > 0) {
      const file = event.target.files[0];
      this.certFile = file;
    }
  }

  onReset(): void {
    this.pasForm.reset();
    $('#passport_modal').modal('hide');
  }
  
  editEmpPassport(passportId) : void {
    console.log( ' edit passport id', passportId);
    this.empService.editEmpPassport(passportId).subscribe( res => {
      this.result = res;
      console.log('edit ' , this.result);
    });
  }

}
